import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-strava', 'BrandStrava', [["path",{"d":"M15 13l-5 -10l-5 10m6 0l4 8l4 -8","key":"svg-0"}]]);